import { api } from '@services';

export interface IVerifyInUseEquipmentStatusResponse {
  inUse: boolean;
  onlyLeft: boolean;
  assets: number;
}

const verifyInUseEquipmentStatus = async (
  id: string,
): Promise<IVerifyInUseEquipmentStatusResponse> => {
  const { data: inUseData } =
    await api.get<IVerifyInUseEquipmentStatusResponse>(
      `/equipmentStatus/${id}/inUse`,
    );

  return inUseData;
};

export { verifyInUseEquipmentStatus };
